import { render, staticRenderFns } from "./MaterialTemplatesPage.vue?vue&type=template&id=63d5d5fa&scoped=true"
import script from "./MaterialTemplatesPage.vue?vue&type=script&lang=ts"
export * from "./MaterialTemplatesPage.vue?vue&type=script&lang=ts"
import style0 from "./MaterialTemplatesPage.vue?vue&type=style&index=0&id=63d5d5fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d5d5fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d5d5fa')) {
      api.createRecord('63d5d5fa', component.options)
    } else {
      api.reload('63d5d5fa', component.options)
    }
    module.hot.accept("./MaterialTemplatesPage.vue?vue&type=template&id=63d5d5fa&scoped=true", function () {
      api.rerender('63d5d5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/MaterialTemplatesPage.vue"
export default component.exports